import { BeforeAfterGalleryContent } from './before-after-gallery-content.model';

export class BeforeAfterGallery {
  public id: number;
  public image_count: number;
  public age_warning: boolean;
  public logo: string;
  public name: string;
  public procedure: number;
  public sharing_message: string;
  public position: number;
  public shared_on_app: boolean;
  public shared_on_web: boolean;
  public default_view: number;
  public contents: any[];
  public description: string;

  public _selected: boolean;

  public watermark_image: string;
  public watermark_font: number;
  public watermark_horizontal_nudge: number;
  public watermark_horizontal_nudge_type: number;
  public watermark_position: number;
  public watermark_text: string;
  public watermark_type: number;
  public watermark_vertical_nudge: number;
  public watermark_vertical_nudge_type: number;

  public gallery_group_id?: number;

  // public is_stock: [boolean, string];
  // public is_deleted: boolean;

  constructor(data: any = {}) {
    this.id = data.id || void 0;
    this.image_count = data.image_count || 0;
    this.age_warning = data.age_warning || false;
    this.shared_on_app = data.shared_on_app;
    this.shared_on_web = data.shared_on_web;
    this.name = data.name || null;
    this.procedure = data.procedure || void 0;
    this.sharing_message = data.sharing_message || void 0;
    this.position = data.position;
    this.contents = data.contents || [];
    this.description = data.description || '';
    this.logo = data.logo || null;
    this.default_view = data.default_view || 2;

    this._selected = data._selected || false;

    // this._formContent(data);

    this.watermark_image = data.watermark_image;
    this.watermark_font = data.watermark_font;
    this.watermark_horizontal_nudge = data.watermark_horizontal_nudge;
    this.watermark_horizontal_nudge_type = data.watermark_horizontal_nudge_type;
    this.watermark_position = data.watermark_position;
    this.watermark_text = data.watermark_text;
    this.watermark_type = data.watermark_type;
    this.watermark_vertical_nudge = data.watermark_vertical_nudge;
    this.watermark_vertical_nudge_type = data.watermark_vertical_nudge_type;

    // this.is_deleted = data.is_deleted || void 0;
    // this.is_stock = data.is_stock || [false, ''];
  }

  private _formContent(data) {
    const items =
      data.contents &&
      data.contents.map((content) => {
        const item = new BeforeAfterGalleryContent(content);
        item.gallery_id = data.id; // needs parent
        return item;
      });
    this.contents = items || [];
  }

  public getClone() {
    const clone = new BeforeAfterGallery();
    clone.name = `${this.name} (Clone)`;
    return clone;
  }

  public setSelected(selected: boolean) {
    this._selected = selected;
  }
}
